'use client';
import React from 'react';
import { DifficultyType } from './CourseCatalogContent';

interface CourseFiltersProps {
  difficulty: DifficultyType;
  onDifficultyChange: (v: DifficultyType) => void;
}

const difficulties: { id: DifficultyType; label: string; color: string }[] = [
  { id: 'all', label: 'All Levels', color: 'text-foreground' },
  { id: 'beginner', label: 'Beginner', color: 'text-emerald-600' },
  { id: 'intermediate', label: 'Intermediate', color: 'text-blue-600' },
  { id: 'advanced', label: 'Advanced', color: 'text-purple-600' },
];

export default function CourseFilters({ difficulty, onDifficultyChange }: CourseFiltersProps) {
  return (
    <div className="p-4 bg-muted/50 border border-border rounded-xl fade-in">
      <div className="flex flex-wrap gap-6">
        <div>
          <p className="text-xs font-semibold uppercase tracking-wide text-muted-foreground mb-2">Difficulty</p>
          <div className="flex items-center gap-2 flex-wrap">
            {difficulties.map((d) => (
              <button
                key={`diff-${d.id}`}
                onClick={() => onDifficultyChange(d.id)}
                className={`px-3 py-1.5 rounded-lg text-sm font-medium border transition-all ${
                  difficulty === d.id
                    ? 'bg-primary text-primary-foreground border-primary'
                    : 'bg-card border-border text-muted-foreground hover:text-foreground hover:bg-card'
                }`}
              >
                {d.label}
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}